module.exports = __webpack_public_path__ + "static/media/YF70_2.898e4005.jpg";